import { render, staticRenderFns } from "./install-pwa-banner.vue?vue&type=template&id=6ebd72c0&scoped=true&"
import script from "./install-pwa-banner.vue?vue&type=script&lang=js&"
export * from "./install-pwa-banner.vue?vue&type=script&lang=js&"
import style0 from "./install-pwa-banner.vue?vue&type=style&index=0&id=6ebd72c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebd72c0",
  null
  
)

export default component.exports